import React, { useState } from 'react'
import Filter from '../../context/Filter'
import { withProfile } from '../../context/Profile'
import { withCatalog } from '../../context/Catalog'
import ToggleCardList from '../../components/ToggleCardList'

import ExportButtons from './_ExportButtons'
import Cards from './Cards'
import Filters from './Filters'

import {
  FiFilter
} from 'react-icons/fi'

function Board( props ) {
  const { profile } = props.withProfile
  const [ isFilterOpened, setIsFilterOpened ] = useState( false )

  function toggleFilter() {
    setIsFilterOpened( ! isFilterOpened )
  }

  if ( ! profile._id )
    return null

  return (
    <Filter>
      <main>
        <header>
          <h1>Detalle de las acciones</h1>

          <div className="actions">
            <ExportButtons />

            <button onClick={ toggleFilter }>
              <FiFilter />
            </button>
          </div>
        </header>

        <section className="vs">

          <div className="hs padding overflow-y">
            <Cards before={ [
              // {
              //   __external: {
              //     from: 'datos',
              //     localField: 'obra_interno',
              //     foreignField: 'IdObraInternoCEDRO',
              //     match: { Plataforma: { $ne: 'Denuncia' } },
              //     unique: true
              //   }
              // }
            ] } />
          </div>

          <footer className="hs center">
            <ToggleCardList />
          </footer>


        </section>

      </main>

      { isFilterOpened ? <Filters
        close={ toggleFilter }
      /> : null }

    </Filter>
  )
}

export default withCatalog( withProfile( Board ) )
